import { cn } from '@workspace/ui/lib/utils';

interface DividerProps {
  direction: 'horizontal' | 'vertical';
}

export function Divider({ direction }: DividerProps) {
  return (
    <div
      className={cn(
        'bg-border-divider',
        direction === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
      )}
    />
  );
}
